import { useTheme } from '@/hooks/useTheme';
import BrandLogo from '@/components/feature/BrandLogo';
import { brandLogoTone } from '@/lib/placeholders';

export default function PageLoadingFallback() {
  const { isDark } = useTheme();

  return (
    <div
      className={`flex items-center justify-center h-[calc(100dvh-192px)] backdrop-blur-lg ${
        isDark
          ? 'bg-gradient-to-br from-dark via-dark-100 to-[#1A1614]'
          : 'bg-gradient-to-br from-ivory via-cream to-sand'
      }`}
    >
      <div className="flex flex-col items-center gap-4">
        <BrandLogo className={`w-14 h-14 animate-pulse ${brandLogoTone(isDark)}`} />
        <div className="flex items-center gap-2">
          <div
            className={`w-2 h-2 rounded-full ${
              isDark ? 'bg-gold' : 'bg-gold-dark'
            } animate-bounce`}
            style={{ animationDelay: '0ms' }}
          />
          <div
            className={`w-2 h-2 rounded-full ${
              isDark ? 'bg-gold' : 'bg-gold-dark'
            } animate-bounce`}
            style={{ animationDelay: '150ms' }}
          />
          <div
            className={`w-2 h-2 rounded-full ${
              isDark ? 'bg-gold' : 'bg-gold-dark'
            } animate-bounce`}
            style={{ animationDelay: '300ms' }}
          />
        </div>
        <span
          className={`text-sm font-medium tracking-wider uppercase ${
            isDark ? 'text-gray-300' : 'text-gray-600'
          }`}
        >
          Loading
        </span>
      </div>
    </div>
  );
}
